import { GET_ALL_ENTREPRISES } from "../actions/allEntreprises.actions";

const initialState = {};

export default function allEntreprisesReducer(state = initialState, action) {
  switch (action.type) {
    case GET_ALL_ENTREPRISES:
      return action.payload;
    default:
      return state;
  }
}
